const PropTypes = require('prop-types');
const React = require('react');
const UrlHelpers = require('components/shared/url_helpers.js');
const User = require('components/user.js');
const TransitionElement = require('components/shared/transition_element.jsx');
const { UI } = require('components/legacy/ui.js');
const { Tracker } = require('@reverbdotcom/discovery-ui');

const popupTimeout = 3000; // ms

class WatchButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isWatching: this.props.isWatching,
    };

    this.hideResponseCallback = null;
  }

  get isWatching() {
    return this.state.isWatching;
  }

  trackClick() {
    const eventData = {
      name: 'WatchButton',
      interaction: 'watch',
      type: 'listing',
      id: this.props.productId,
    };
    if (this.isWatching) { eventData.interaction = 'unwatch'; }

    Tracker.trackInteraction(eventData);
  }

  handleClick(e) {
    this.trackClick();

    if (!UI.isLoggedIn()) {
      User.showInlineRegistrationOrLogin(e, e.target);
      return;
    }
    if (this.props.isOwner) {
      this.showSellerBlock();
      return;
    }

    if (this.isWatching) {
      this.removeWatch();
    } else {
      this.addWatch();
    }
  }

  showSellerBlock() {
    Reverb.BlockSellerAction.showMessage(I18n.t('js.watchButton.sellerBlockMessage'));
  }

  showResponse() {
    this.setState({ showResponse: true });
    window.clearTimeout(this.hideResponseCallback);
    this.hideResponseCallback = window.setTimeout(() => this.hideResponse(), popupTimeout);
  }

  hideResponse() {
    this.setState({ showResponse: false });
  }

  addWatch() {
    this.setState({ isWatching: true });
    this.showResponse();

    Reverb.APIRequest.V3.post(
      UrlHelpers.watchProductPath(this.props.productId)
    );
  }

  removeWatch() {
    this.setState({ isWatching: false });
    this.showResponse();

    Reverb.APIRequest.V3.destroy(
      UrlHelpers.unwatchProductPath(this.props.productId)
    );
  }

  renderWatchBenefits() {
    if (UI.isLoggedIn()) { return null; }

    return (
      <div
        className="hidden"
        id="watch-benefits"
      >
        <div className="watch-benefits alert alert-info">
          <div className="g-container">
            <div className="g-col-3 hidden-desktop">
              <img src={this.props.productImage} role="presentation" />
            </div>
            <div className="g-col-9">
              <h4 className="heading-4 mb-half">{I18n.t('js.watchButton.benefits.signUp')}</h4>
            </div>
          </div>
          <div className="g-container">
            <div className="g-col-3 g-col-mobile-12 hidden-mobile">
              <div className="center">
                <img src={this.props.productImage} role="presentation" width="64" height="64" />
              </div>
            </div>
            <div className="g-col-9 g-col-mobile-12">
              <ul className="fa-ul small">
                <li>
                  <span className="fa fa-check fa-li color-green" />
                  {I18n.t('js.watchButton.benefits.priceDrop')}
                </li>
                <li>
                  <span className="fa fa-check fa-li color-green" />
                  {I18n.t('js.watchButton.benefits.offers')}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderBtnText() {
    if (this.isWatching) {
      return I18n.t('js.watchButton.button.watching');
    }
    return I18n.t('js.watchButton.button.watch');
  }

  renderInnerResponse() {
    if (this.state.isWatching) {
      return I18n.t('js.watchList.itemAdded', {
        link_open: `<a href="${UrlHelpers.watchedProductsPath}">`,
        link_close: '</a>',
      });
    }

    return I18n.t('js.watchList.itemRemoved');
  }

  renderResponse() {
    if (!this.state.showResponse) { return ''; }

    return (
      <div
        className="tooltip-panel__content tooltip-panel__content--watch"
        dangerouslySetInnerHTML={{ __html: this.renderInnerResponse() }}
      />
    );
  }

  render() {
    const btnClass = this.state.isWatching ? 'icon-l-star' : 'icon-l-star-o';
    return (
      <div>
        <a
          className={`wide ${btnClass}`}
          onClick={(e) => this.handleClick(e)}
          data-registration-url-source="product_watch"
          data-registration-explanation-content="#watch-benefits"
          data-registration-source-product-uuid={this.props.sourceProductUuid}
        >
          {this.renderBtnText()}
        </a>
        <TransitionElement>{this.renderResponse()}</TransitionElement>
        {this.renderWatchBenefits()}
      </div>
    );
  }
}

WatchButton.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isWatching: PropTypes.bool.isRequired,
  productImage: PropTypes.string.isRequired,
  sourceProductUuid: PropTypes.string.isRequired,
  isOwner: PropTypes.bool,
};

WatchButton.defaultProps = {
  isOwner: false,
};

module.exports = WatchButton;



// WEBPACK FOOTER //
// ./javascripts/components/listings/watch_button.jsx